// removed by extract-text-webpack-plugin
module.exports = {"pending__content":"PendingPage-module__pending__content___34dTu","pending__title":"PendingPage-module__pending__title___1oZ86","pending__message":"PendingPage-module__pending__message___V65id"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/PendingPage/PendingPage.module.css
// module id = 638
// module chunks = 0